<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
      <div class="row">
          <div class="col-md-6">
            <label for="policy_number">
              {{ $t("policy_number") }}
            </label>
            <app-input
              id="policy_number"
              type="text"
              :required="true"
              v-model="inputs.policy_number"
            />
          </div>
          <div class="col-md-6">
            <label for="insurance_type">
              {{ $t("insurance_type") }}
            </label>
            <app-input
              id="insurance_type"
              type="text"
              :required="true"
              v-model="inputs.insurance_type"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <label for="insurance_company">
              {{ $t("insurance_company") }}
            </label>
            <app-input
              id="insurance_company"
              type="text"
              v-model="inputs.insurance_company"
            />
          </div>
          <div class="col-md-6">
            <label for="expiry_date">
              {{ $t("expiry_date") }}
            </label>
            <app-input
              id="expiry_date"
              type="date"
              v-model="inputs.expiry_date"
            />
          </div>
          <div class="col-md-12">
            <label for="file_upload">
              {{ $t("attachment") }}
            </label>
            <app-input
              type="file"
              :label="$t('attachment')"
              v-model="inputs.insurance_file"
            />
            <p v-if="fileView" class="mt-4">Last Upload: <span><a :href="fileUrl" download="download">View Insurance File</a></span></p>
          </div>
        </div>      
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";


export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  extends: AppLibrary,

  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      addurl:actions.COMPANY_INSURANCE_STORE,
      preloader: false,
      roleLists: [],
      inputs: {
        head_office: 'yes',
        company_id: this.companyId,
      },
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      fileUrl: '',
      fileView: false,
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      this.inputs.expiry_date = this.getDateFormatForBackend(this.inputs.expiry_date)

      let formData = new FormData;
          for (const [key, value] of Object.entries(this.inputs)) {
              formData.append(key, value);
          }
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_INSURANCE_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      if(response.data.file) {
        this.fileUrl = response.data.file;
        this.fileView =true;
      }
      this.preloader = false;
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
